// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"e1977908","447":"e1977908"}[chunkId] + ".chunk.css";
};